import React, { useState } from "react"
import Button from "@cmp/shared/Button/Button"
import classes from './Media.module.css'
import {TbMaximize} from 'react-icons/tb'
import {FaXmark} from 'react-icons/fa6'
import YouTube from 'react-youtube';
import getVideoId from 'get-video-id';
import { createPortal } from "react-dom"
import { MdFullscreen } from "react-icons/md"

const youtubeConfig = {

  autoplay: 0,
  controls: 1,
  cc_load_policy: 0,
  fs: 1,
  iv_load_policy: 3,
  modestbranding: 1,
  rel: 0,
  showinfo: 0,
}

const getMediaType = (path) => {
  let videoId = getVideoId(path)

  if(videoId.service === "youtube") {
    return "youtube"
  }

  let types = {
    image: ["jpg", "jpeg", "png", "gif"],
    video: ["mp4", "avi", "mov"],
  }

  let ext = path.split(".").pop()

  for(let type of Object.keys(types)) {
    if(types[type].includes(ext.toLowerCase())) {
      return type
    }
  }

  return null
}

const Media = ({path, fullscreenPath = null, bgColor = null}) => {
  const [showFullscreen, setShowFullscreen] = useState(false);

  let type = getMediaType(path)

  let filepath = path
  let fsFilepath = fullscreenPath ? fullscreenPath : path

  return (
    <div className={classes.media} style={bgColor ? { background: "#FFF"} : undefined} >

      {type=== "youtube" &&
      <YouTube
      className="youtube-player"
      iframeClassName="youtube-player-iframe"
      videoId={getVideoId(path).id} opts={{ height: '300', width: '100%', playerVars: youtubeConfig}} />}


      {type==="image" &&
      <img src={path} alt="" draggable={false}/>}

      {type === "video" &&
      <video controls src={path} autoPlay></video>}

      {type === "image" &&
      <Button
        data-no-dnd="true"
        onClick={() => setShowFullscreen(true)} icon={<MdFullscreen />}
        className={classes.media_fullscreen} />}



    {showFullscreen &&
      createPortal(
        <div className={classes.fullscreenmedia}  data-no-dnd="true" >
          {type==="image" &&
          <img onClick={e => e.stopPropagation()} src={fsFilepath} alt=""  draggable={false}/>}

          <Button onClick={() => setShowFullscreen(false)} className={classes.media_fullscreen} icon={<FaXmark />} />
        </div>,
        document.querySelector(".App")
      )}

    </div>
  )

}


export default Media
